import { useNavigate } from 'react-router-dom';

import { Menu, rem } from '@mantine/core';

import { AppRoutes } from '@/router/routes.ts';

import { IconChartInfographic } from '@tabler/icons-react';

export const ReportsSection = () => {
	const navigate = useNavigate();

	return (
		<>
			<Menu.Item
				fz="md"
				fw={600}
				leftSection={
					<IconChartInfographic style={{ width: rem(16), height: rem(16) }} stroke={1.5} />
				}
				onClick={() => navigate(AppRoutes.Statistics)}
			>
				Статистика
			</Menu.Item>
		</>
	);
};
